import React, { useState } from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { Modal, ModalBody } from "react-bootstrap";
import "../modal.css";
import { useDispatch } from "react-redux";
import SelectField from "../../form/selectField/selectField";
import { invoiceReupload } from "../../../redux/actions/invoiceVerificationAction";
import SuccessPopup from "../../popups/SuccessPopup";
import ErrorPopup from "../../popups/ErrorPopup";
import { useNavigate } from "react-router-dom";

const PtrUpdateModal = ({ show, handleClose, data, cfaUser }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();

  const inValues = {
    user_type: "",
    order_type: cfaUser ? "" : "distributor_order",
  };

  const validationSchema = Yup.object().shape({
    user_type: Yup.string().required("Required"),
  });

  const onSubmit = (values) => {};

  //   const timeOutFnc = () => {
  //     setShowSuccessPopup(false);
  //     navigate("/support/invoice-verification");
  //   };

  //   const onSuccess = (data) => {
  //     console.log(data);
  //     handleClose();
  //     setShowSuccessPopup(true);
  //     const str = data.data.message;
  //     const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
  //     setShowSuccessMsg(str_modify);
  //     setTimeout(timeOutFnc, 2000);
  //   };

  //   const onError = (err) => {
  //     console.log(err);
  //     const str = err.data.message;
  //     const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
  //     setShowErrorMsg(str_modify);
  //     setShowErrorPopup(true);
  //     setTimeout(() => {
  //       setShowErrorPopup(false);
  //     }, 2500);
  //   };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const orderOptions = [
    { value: "cfa_order", label: "CFA Order Invoice" },
    { value: "distributor_order", label: "Distributor Order Invoice" },
  ];
  return (
    <>
      <Modal
        centered
        show={show}
        onHide={handleClose}
        dialogClassName=""
        contentClassName="link-modal col-5 mx-auto p-2 fn_Nunito"
      >
        <ModalBody>
          <Formik
            initialValues={inValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize={true}
          >
            {({ setFieldValue, values }) => (
              <Form className="p-1">
                <p className="fn_Nunito fw_700 fs_18 my-2 px-0">Update PTR</p>

                <div className="my-3 mt-4">
                  <span className="color_262C3D fs_16 fw_500">
                    Current PTR :
                  </span>{" "}
                  <span className="fw_700 fs_16">₹ 4453</span>
                </div>

                <div className="my-2">
                  <SelectField
                    label={"Select new PTR"}
                    labelColor={"color_262c3d"}
                    placeholder={"Select PTR"}
                    optionList={orderOptions}
                    name={"order_type"}
                    id={"order_type"}
                    menuHeight="130px"
                    value={""}
                  />
                </div>

                <div className="d-flex justify-content-end align-items-center gap-3">
                  <button
                    type="button"
                    onClick={() => handleClose()}
                    className="modal-logout-btn fs_14 fw_700 px-4 py-2"
                    style={{ width: "130px" }}
                  >
                    NO
                  </button>
                  <button
                    type="submit"
                    className="modal-cancel-btn fs_14 text-white py-2 px-4 fw_700"
                    style={{ width: "130px" }}
                  >
                    Send
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </Modal>
      <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </>
  );
};

export default PtrUpdateModal;
